export default palette => ({
  root: {
    color: palette.text.primary,
  },
})
